<template>
  <v-card class="text-center" min-height="370">
    <v-card-title>
    </v-card-title>
    <v-card-text class="text-center text-h5">
      Thank you!
    </v-card-text>
    <v-icon color="primary" size="100">mdi-check-circle</v-icon>
    <v-card-text class="text-center text-h6">
      Your request has been submitted, we will contact you soon.
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        rounded x-large color="primary"
        min-width="100"
        @click="$emit('close')"
      >
        Ok
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "SuccessBuyingRequest",
}
</script>

<style scoped>
.centered {

}
</style>